module.exports = __webpack_public_path__ + "img/location.a2403633.svg";